// extracted by mini-css-extract-plugin
export var body = "CreateTeamModal-module__body___Xow4S";
export var cancelButton = "CreateTeamModal-module__cancelButton___FDJa8";
export var closeButton = "CreateTeamModal-module__closeButton___lx3Ol";
export var emptyMessage = "CreateTeamModal-module__emptyMessage___7PkXT";
export var errorMessage = "CreateTeamModal-module__errorMessage___8ULHF";
export var fieldHint = "CreateTeamModal-module__fieldHint___bkCsD";
export var fieldLabel = "CreateTeamModal-module__fieldLabel___DqyJn";
export var footer = "CreateTeamModal-module__footer___T6+lA";
export var header = "CreateTeamModal-module__header___w5oWG";
export var memberCheckbox = "CreateTeamModal-module__memberCheckbox___tAECT";
export var memberEmail = "CreateTeamModal-module__memberEmail___oNjWV";
export var memberInfo = "CreateTeamModal-module__memberInfo___RYU5F";
export var memberItem = "CreateTeamModal-module__memberItem___II2AC";
export var memberList = "CreateTeamModal-module__memberList___jKc0+";
export var memberName = "CreateTeamModal-module__memberName___+X5j6";
export var modal = "CreateTeamModal-module__modal___+4zVV";
export var nameInput = "CreateTeamModal-module__nameInput___XTmHU";
export var overlay = "CreateTeamModal-module__overlay___uAwaN";
export var searchInput = "CreateTeamModal-module__searchInput___J9pnZ";
export var submitButton = "CreateTeamModal-module__submitButton___Bx8P3";
export var title = "CreateTeamModal-module__title___6mKXb";